import { userConstants } from "../../constant";

const initialState = {
  disputes: [],
};

export function sellerDisputes(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_SELLER_DISPUTES:
      return { ...state, disputes: action.disputes };

    case userConstants.RESPOND_TO_DISPUTE: {
      const updated = action.dispute;
      return {
        ...state,
        disputes: state.disputes.map((d) =>
          d.id === updated.id ? updated : d
        ),
      };
    }

    default:
      return state;
  }
}
